module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4b-4ddf99148c90712dc63148523a48b004.png";